<template>
<div>
  <el-form style="margin-right: 30px" :model="addEditForm" :rules="addEditRules" ref="addEditForm" label-width="140px" class="demo-ruleForm">
    <el-form-item label="收费项目" prop="project_id">
      <el-select v-fixZoom v-model="addEditForm.project_id" filterable placeholder="请选择" style="width: 100%">
        <el-option v-for="item in financeProject" :key="item.id" :label="item.project_name" :value="item.id">
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="扣费顺序" prop="project_order">
      <el-select v-fixZoom v-model="addEditForm.project_order" filterable placeholder="请选择" style="width: 100%">
        <el-option v-for="item in projectOrderArr" :key="item.id" :label="item.name" :value="item.id">
        </el-option>
      </el-select>
    </el-form-item>
  </el-form>
  <div style="height: 50px">
    <el-row style="margin: 0 30px">
      <el-col :span="12">
        <div class="cancel-btn" @click="closeAddEdit()">
          <span>取消</span>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="send-btn" @click="submitAddEdit('addEditForm')">
          <span>确定</span>
        </div>
      </el-col>
    </el-row>
  </div>
</div>
</template>

<script>
import {setelderlyfinanceproject, updateelderlyfinanceproject} from '../../../api/yanglaoyuan'

export default {
  name: 'addEditSetProject',
  model: {
    prop: 'bedShow',
    event: 'change'
  },
  props: {
    projectRow: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      financeProject: [],
      projectOrderArr: [
        {id: 1, name: '周期前扣费'},
        {id: 2, name: '周期后扣费'}
      ],
      addEditForm: {
        id: 0,
        epid: '',
        eid: '',
        efp_id: 0, // 暂无意义
        project_id: '',
        project_order: '',
        change_time: ''
      },
      addEditRules: {
        project_id: [
          {required: true, message: '请选择收费项目', trigger: 'change'}
        ],
        project_order: [
          {required: true, message: '请选择收费顺序', trigger: 'blur'}
        ]
      }
    }
  },
  created () {
    this.financeProject = this.projectRow.financeProject
    this.addEditForm.epid = this.projectRow.billRow.epid
    this.addEditForm.eid = this.projectRow.billRow.eid
    if (!this.projectRow.isAdd) {
      this.addEditForm.id = this.projectRow.row.id
      this.addEditForm.efp_id = this.projectRow.row.efp_id
      this.addEditForm.project_id = this.projectRow.row.project_id
      this.addEditForm.project_order = this.projectRow.row.project_order
    }
  },
  methods: {
    closeAddEdit () {
      this.$emit('change', false)
    },
    submitAddEdit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {
            id: this.addEditForm.id,
            epid: this.addEditForm.epid,
            eid: this.addEditForm.eid,
            efp_id: this.addEditForm.efp_id, // 暂无意义
            project_id: this.addEditForm.project_id,
            project_order: this.addEditForm.project_order
          }
          if (this.projectRow.isAdd) {
            setelderlyfinanceproject(data).then(res => {
              this.$notify({title: '成功', message: '成功新增收费项目', type: 'success', duration: 2000})
              this.$emit('updateTable')
              this.$emit('change', false)
            })
          } else {
            updateelderlyfinanceproject(data).then(res => {
              this.$notify({title: '成功', message: '成功编辑收费项目', type: 'success', duration: 2000})
              this.$emit('updateTable')
              this.$emit('change', false)
            })
          }
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/components/addEditSetProject.vue